// extracted by mini-css-extract-plugin
module.exports = {"width100":"w_cs f_cs","design3Pos":"w_sY f_cX"};